import { render, staticRenderFns } from "./CustomFieldSectionEditor.vue?vue&type=template&id=6ab95cc8&"
import script from "./CustomFieldSectionEditorVue.ts?vue&type=script&lang=ts&"
export * from "./CustomFieldSectionEditorVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports